import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  Global = Global;
  loginForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
  ) {
    this.loginForm = formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
  }

  login(event: any) {
    this.loginForm.markAllAsTouched();
    Global.scrollToQuery(".form-control.is-invalid");

    if (this.loginForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService.adminLogin({
        'email': this.loginForm.value.email,
        'password': this.loginForm.value.password,
      }).subscribe(res => {
        if (res.status == 'success') {
          this.toastr.success(res.message);
          localStorage.setItem('calplay-admin-token', res.token);
          localStorage.setItem('calplay-admin-user', JSON.stringify(res.admin));
          this.router.navigate(['/home']);
        } else if (res.status == 'val_error') {
          this.toastr.error(Global.getValidationMessage(res?.errors ?? []));
        } else {
          this.toastr.error(res.message);
        }

        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
      }, (err) => {
        event.target.classList.remove('btn-loading');
        event.target.disabled = false;
        this.toastr.error(Global.getServerErrorMessage(err));
      });
    }
  }
}
